import { createFileRoute } from '@tanstack/react-router';

import { LinkPage } from '@/links/pages/link';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/links/$linkId')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: LinkDetailRoute
});

function LinkDetailRoute() {
  const { linkId } = Route.useParams();
  const { match, id, slug } = parseLinkId(linkId);

  // TODO: move this matching to the route handler above
  if (!match) {
    return null;
  }

  return <LinkPage id={id} slug={slug}/>;
}

type ParsedLinkId =
  | { match: true; id: number; slug: string; }
  | { match: false; id: undefined; slug: undefined; };

function parseLinkId(linkId: string): ParsedLinkId {
  const match = linkId.match(/^(.+)-(\d+)$/);

  if (!match) {
    return {
      match: false,
      id: undefined,
      slug: undefined
    };
  }

  const [, slug, idStr] = match;
  const id = parseInt(idStr, 10);

  // Additional validation
  if (isNaN(id) || id <= 0) {
    return {
      match: false,
      id: undefined,
      slug: undefined
    };
  }

  return { match: true, slug, id };
}
